import { Box, CircularProgress } from '@material-ui/core';
import React from 'react';

const Loader = () => {
  return (
    <Box
      alignItems="center"
      display="flex"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress data-testid="authentication-loading" />
    </Box>
  );
};

export default Loader;
